import { useContext } from 'react';

import { TimeseriesGapPolicyContext } from '../context/TimeseriesGapPolicy.context.js';

export const useGapPolicy = () => useContext(TimeseriesGapPolicyContext);
